/**
 * Acceso — login.html compuesto con @skein/ui: SSO del equipo con Entra ID.
 * `sinRol`: la cuenta ENTRÓ pero no tiene rol de aplicación y la API la
 * para (ADR-14 pt 6, «sin rol, nada»): el estado `sin-acceso` del
 * prototipo, con la salida a mano para entrar con otra cuenta.
 */
import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { Banner, Brand, Button, Card, Envline, Fainted, Flight, Help, Overline, Symbol, Whisper } from "@skein/ui";
import { loginRequest } from "../../auth/msal";
import { classify, setLoginError, useLoginError, watchEntra } from "../../auth/loginState";
import { ENV } from "../../env";

export function LoginPage({ sinRol, onSalir }: { sinRol?: boolean | undefined; onSalir?: (() => void) | undefined } = {}) {
  const { instance, inProgress } = useMsal();
  const leido = useLoginError();
  const error = sinRol === true ? "sin-acceso" : leido;
  const busy = inProgress !== InteractionStatus.None && sinRol !== true;
  useEffect(() => (error === "red" ? watchEntra(`https://login.microsoftonline.com/${ENV.tenantId}`) : undefined), [error]);
  const entrar = () => { setLoginError(null); instance.loginRedirect(loginRequest).catch((e: unknown) => setLoginError(classify(e))); };
  return (
    <div className="acceso">
      <div />
      <Flight contained once className="cielo" />
      <div className="puerta">
        {error === "sin-acceso" && <Banner tone="danger"><b>Tu cuenta no tiene acceso al Studio.</b> Pide a un admin de Skein que te añada al equipo — la invitación llega por correo.{onSalir && <> <Button variant="link" onClick={onSalir}>cerrar sesión</Button></>}</Banner>}
        {error === "caducada" && <Banner tone="info"><b>Tu sesión caducó.</b> Vuelve a entrar — el trabajo quedó guardado donde lo dejaste.</Banner>}
        {error === "red" && <Banner tone="danger"><b>No llego al servicio de acceso.</b> Entra ID no responde — reintento solo cada 30 s. <Button variant="link" onClick={entrar}>reintentar ahora</Button></Banner>}
        <Card hero>
          <Symbol size={40} />
          <Brand size="var(--sk-fs-xl)" style={{ marginTop: "var(--sk-sp-3)" }} />
          <Overline style={{ marginTop: "var(--sk-sp-2)" }}>Studio</Overline>
          <Whisper style={{ margin: "var(--sk-sp-4) 0 var(--sk-sp-6)" }}>El taller donde se cura el criterio de los asesores.</Whisper>
          <Button variant="primary" block loading={busy} disabled={error === "sin-acceso" || error === "red"} onClick={entrar}>Entrar con Microsoft</Button>
          <Help style={{ marginTop: "var(--sk-sp-4)" }}>Acceso del equipo con Entra ID — sin contraseñas propias que custodiar.</Help>
        </Card>
        <Fainted block style={{ textAlign: "center", fontSize: "var(--sk-fs-xs)" }}>¿Eres executive? Tu asesor no vive aquí — te espera en el Despacho.</Fainted>
      </div>
      <Envline bare className="pie">{ENV.label} · eu-west</Envline>
    </div>
  );
}
